<template>
  <v-container class="py-1">
    <v-row dense>
      <v-col cols="4">
        <v-row dense>
          <v-col
            cols="4"
            class="pr-2 text-right"
          >
            <div class="text-body-2 field-label">
              {{ $t('m.cargoType') }}
            </div>
            <div class="text-body-2 field-label">
              {{ $t('m.lPort') }}
            </div>
            <div class="text-body-2 field-label">
              {{ $t('m.dPort') }}
            </div>
          </v-col>
          <v-col cols="8">
            <v-text-field
              v-model="form.Cargo"
              :readonly="isRotating"
              dense
              hide-details
            />
            <v-autocomplete
              v-model="loadPortSelect"
              hide-details
              dense
              clearable
              :disabled="isRotating"
              :items="fromItems"
              :loading="isLoadingPort"
              :search-input.sync="loadPortSearch"
              hide-no-data
              item-text="FULLNAME"
              item-value="PORTID"
              return-object
              class="text-body-2"
            />
            <v-autocomplete
              v-model="dischargePortSelect"
              hide-details
              dense
              clearable
              :disabled="isRotating"
              :items="toItems"
              :loading="isLoadingDischargePort"
              :search-input.sync="dischargePortSearch"
              hide-no-data
              item-text="FULLNAME"
              item-value="PORTID"
              return-object
              class="text-body-2"
            />
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="3">
        <v-row dense>
          <v-col
            cols="5"
            class="pr-2  text-right"
          >
            <div class="text-body-2 field-label">
              {{ $t('m.cargoQuantity') }}
            </div>
            <div class="text-body-2 field-label">
              {{ $t('m.fee') }}
            </div>
            <div class="text-body-2 field-label">
              {{ $t('m.income') }}
            </div>
          </v-col>
          <v-col cols="7">
            <v-text-field
              v-model="form.Quantity"
              hide-details
              type="number"
              dense
              suffix="MT"
            />
            <v-text-field
              v-model="form.Freight"
              type="number"
              dense
              required
              hide-details="true"
              suffix="/ MT"
            />
            <v-text-field
              v-model="form.Income"
              dense
              disabled
              hide-details="true"
            />
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="5">
        <v-row dense>
          <v-col
            cols="4"
            class="pr-2 text-right"
          >
            <div class="text-body-2 field-label">
              {{ $t('m.addCommRate') }}
            </div>
            <div class="text-body-2 field-label">
              {{ $t('m.brokerageRate') }}
            </div>
            <div class="text-body-2 field-label">
              {{ $t('m.frtTaxRate') }}
            </div>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="form.AddCommRate"
              dense
              hide-details="true"
              suffix="%"
              type="number"
            />
            <v-text-field
              v-model="form.BrokerageRate"
              dense
              hide-details="true"
              suffix="%"
              type="number"
            />
            <v-text-field
              v-model="form.FrtTaxRate"
              dense
              hide-details="true"
              suffix="%"
              type="number"
            />
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="form.AddComm"
              dense
              disabled
              hide-details="true"
            />
            <v-text-field
              v-model="form.Brokerage"
              dense
              disabled
              hide-details="true"
            />
            <v-text-field
              v-model="form.FrtTax"
              dense
              disabled
              hide-details="true"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row> <!-- end 最外层 row -->
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Utils from '@/utils/index'
import httpClient from '@/api/httpClient'
import Constant from '@/constant/index'
import EstiTmpl from '@/components/estimation/EstiTmpl'

export default {
  name: 'CargoItemForm',
  components: { },
  props: [
    'index', 'form', 'editFlag', 'model'
  ],
  data () {
    return {
      loadPortSelect: null,
      dischargePortSelect: null,
      isLoadingPort: false,
      isLoadingDischargePort: false,
      fromItems: [],
      loadPortSearch: null,
      dischargePortSearch: null,
      toItems: []
    }
  },
  mounted () {
    if (this.form.LoadPort.portId && this.form.DischargePort.portId) {
      var loadObj = {
        PORTID: this.form.LoadPort.portId,
        FULLNAME: this.form.LoadPort.fullName
      }
      this.loadPortSelect = loadObj
      this.fromItems = [loadObj]

      var dischargeObj = {
        PORTID: this.form.DischargePort.portId,
        FULLNAME: this.form.DischargePort.fullName
      }
      this.dischargePortSelect = dischargeObj
      this.toItems = [dischargeObj]
    }
  },
  watch: {
    form: {
      handler (val) {
        if (this.form.LoadPort.portId && this.form.DischargePort.portId) {
          var loadObj = {
            PORTID: this.form.LoadPort.portId,
            FULLNAME: this.form.LoadPort.fullName
          }
          this.loadPortSelect = loadObj
          this.fromItems = [loadObj]

          var dischargeObj = {
            PORTID: this.form.DischargePort.portId,
            FULLNAME: this.form.DischargePort.fullName
          }
          this.dischargePortSelect = dischargeObj
          this.toItems = [dischargeObj]
        }
      },
      deep: true
    },

    clearFlag: function (val) {
      if (val) {
        this.clearForm()
      }
    },

    editFlag: function (val) {
      if (!val) {
        this.clearForm()
      }
    },

    'form.Cargo': function (val) {
      this.handleFormWatcher()
    },
    'form.Quantity': function (val) {
      this.handleFormWatcher()
    },
    'form.Freight': function (val) {
      this.handleFormWatcher()
    },
    'form.AddCommRate': function (val) {
      this.handleFormWatcher()
    },
    'form.BrokerageRate': function (val) {
      this.handleFormWatcher()
    },
    'form.FrtTaxRate': function (val) {
      this.handleFormWatcher()
    },

    loadPortSelect: function (val) {
      this.selectPort(val, 1)
    },
    dischargePortSelect: function (val) {
      this.selectPort(val, 2)
    },
    loadPortSearch (val) {
      if (!this.loadPortSelect || (val && val !== this.loadPortSelect.FULLNAME)) {
        this.searchPort(val, 1)
      }
      // console.log('loadPortSearch=' + val);
    },
    dischargePortSearch (val) {
      if (!this.dischargePortSelect || (val && val !== this.dischargePortSelect.FULLNAME)) {
        this.searchPort(val, 2)
      }
    }

  },
  computed: {
    ...mapState({
      isRotating: state => state.estimating.isRotating,
      isGettedDistance: state => state.estimating.isGettedDistance,
      cargoTabsArr: state => state.estimating.cargoTabsArr,
      clearFlag: state => state.estimating.clearFlag
    })

  },
  methods: {
    clearForm () {
      this.loadPortSelect = null
      this.dischargePortSelect = null
      this.isLoadingPort = false
      this.isLoadingDischargePort = false
      this.fromItems = []
      this.loadPortSearch = null
      this.dischargePortSearch = null
      this.toItems = []
    },

    handleFormWatcher () {
      if (Number(this.form.Quantity) && Number(this.form.Freight)) {
        this.form.Income = this._.round(this.form.Quantity * this.form.Freight, 2)
      } else {
        this.form.Income = ''
      }

      if (Number(this.form.Income)) {
        this.form.AddComm = Number(this.form.AddCommRate)
          ? this._.round(this.form.Income * this.form.AddCommRate / 100) : ''

        this.form.Brokerage = Number(this.form.BrokerageRate)
          ? this._.round(this.form.Income * this.form.BrokerageRate / 100) : ''

        this.form.FrtTax = Number(this.form.FrtTaxRate)
          ? this._.round(this.form.Income * this.form.FrtTaxRate / 100) : ''
      }

      this.handleAllCommit()
    },

    searchPort (val, pos) { // pos 1- load 2- discharge
      if (!val || this.isLoadingPort || this.isLoadingDischargePort) return
      if (val.trim().length < 2) {
        return
      }
      if (pos == 1) {
        this.isLoadingPort = false
      } else {
        this.isLoadingDischargePort = false
      }
      var postJson = {
        OperID: Utils.getWithExpiry('operID'),
        PortName: val
      }
      httpClient.post('/PortSuggest4API', postJson)
        .then((res) => {
          if (pos == 1) {
            this.fromItems = res.data
          } else {
            this.toItems = res.data
          }
          this.isLoadingPort = false
          this.isLoadingDischargePort = false
        }).catch((err) => {
          this.isLoadingPort = false
          this.isLoadingDischargePort = false
        })
    },

    selectPort (val, pos) {
      if (!val) {
        if (pos == 1) {
          this.form.LoadPort = { portId: '', fullName: '' }
        } else {
          this.form.DischargePort = { portId: '', fullName: '' }
        }
        this.handleAllCommit()
        return
      }
      if (!val.PORTNAME) {
        return
      }
      var postJson = {
        OperID: Utils.getWithExpiry('operID'),
        PortName: val.PORTNAME
      }

      httpClient.post('/SPPortSuggestQry', postJson)
        .then((res) => {
          const obj = res.data.find((p) => p.PORTID === val.PORTID)
          const o = {}
          o.portId = obj.PORTID
          o.portName = obj.FULLNAME.split(',')[0]
          o.fullName = obj.FULLNAME
          o.longitude = Number(obj.LONGITUDE)
          o.latitude = Number(obj.LATITUDE)

          if (pos == 1) {
            this.form.LoadPort = o
          } else {
            this.form.DischargePort = o
          }

          this.handleAllCommit()
        }).catch((err) => {
          console.log(err)
        })
    },

    handleAllCommit () {
      this.$store.commit('updateCargoByIndex', {
        index: this.index,
        form: this.form
      })
    },

    remove () {
      if (this._.trim(this.form.Cargo) &&
          this.form.LoadPort.portId.length > 0 &&
          this.form.DischargePort.portId.length > 0) {
      }

      this.$emit('removeItem', this.index)
    }
  } // end
}
</script>

<style scoped>
  .field-label {
    margin-top: 10px;
  }

</style>
